// src/pages/About.tsx

import React, {ReactElement, FC} from "react";
import {Box, Typography} from "@mui/material";
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import {useNavigate} from "react-router-dom";

const Legend: FC<any> = (): ReactElement => {

    let navigate = useNavigate();
    
    return (
        <Box sx={{
            flexGrow: 1,
            backgroundColor: '#202020',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start'
        }}>
            <Grid container>
            <Grid item style={{height: '10px'}} xs={12}/>
            <Grid item xs={1} />
                <Grid item xs={11}>
                    <FormControl>
                        <FormLabel id="demo-radio-buttons-group-label">
                            <Typography color="#dddddd" variant="h5">
                                Legend
                            </Typography>
                        </FormLabel>
                    </FormControl>
                </Grid>
                <Grid item style={{height: '10px'}} xs={12}/>
                <Grid item xs={1} />
                <Grid item xs={11}>
                    <img src="https://gruze.org/3d/app_legend.png" />
                </Grid>
            </Grid>
        </Box>
    );
};

export default Legend;